<div class="container" >
  <h3 mat-dialog-title>Add new pricing</h3>

  <form (ngSubmit)="submit" #formControl="ngForm">

      <div class="row">
      <div class="form-group form-group-sm">
        <label class="col-md-1">Issuer</label>
        <div class="col-md-3">
          <select class="form-control" matInput #input placeholder="Issuer" required [(ngModel)]="data.IssuerCode" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let cv of data.issuers" [ngValue]="cv.Code">
              {{cv.Description}}
            </option>
          </select>
        </div>
      </div>


      <div class="form-group form-group-sm">
        <label class="col-md-1">Solve For</label>
        <div *ngIf="!data.PriceOff" class="col-md-3">
          <input type="number" class="form-control" step="0.0001" [(ngModel)]="data.SolveFor" (blur)="onBlur($event)"  [ngModelOptions]="{standalone: true}" #inputsolvefor />
        </div>
        <div *ngIf="data.PriceOff" class="col-md-3">
          <input type="text" class="form-control" [(ngModel)]="data.off" [ngModelOptions]="{standalone: true}" [disabled]="true" />
        </div>
      </div>
    </div>
    <div class="row"></div>
    <div class="row">
      <div class="form-group form-group-sm">
        <label class="col-md-1">Comment</label>
        <div class="col-md-7">
          <textarea class="form-control" placeholder="Comment" [(ngModel)]="data.Comment" id="comment" rows="3" name="comment"></textarea>
          <mat-error *ngIf="formControl.invalid">{{getErrorMessage()}}</mat-error>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="col-md-3"> price's Off</label>
          <input class="col-md-1" type="checkbox" [(ngModel)]="data.PriceOff" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>
    </div>


    <div mat-dialog-actions>
      <button class="button" [type]="submit" [disabled]="!formControl.valid" [mat-dialog-close]="1" (click)="confirmAdd()">Save</button>
      <button class="button" (click)="onNoClick()" tabindex="-1">Cancel</button>
    </div>
  </form>
</div>



